import React from "react";
/* css comes in adminMember.css */

import { getInitial } from "../../../../../../DCM/services/utils/name-utils";
import {
  Box,
  Typography,
  Avatar,
  Chip,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";

const IndividualsMember = ({
  teacher,
  inEditingMode,
  setEditingAllMembersDetails,
  editingAllMembersDetails,
  setDeletingAllMembersDetails,
  deletingAllMembersDetails,
  setIsMemberUpdated,
  index,
}) => {
  console.log(teacher, "teach");
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const { deletingTeachers } = deletingAllMembersDetails;
  const handleRoleChange = (e) => {
    setIsMemberUpdated(true);
    !editingAllMembersDetails.some((member) => member.memberId === teacher?.id)
      ? setEditingAllMembersDetails((prev) => [
          ...prev,
          {
            previousRole: teacher?.role,
            nextRole: e.target.value,
            memberId: teacher?.id,
          },
        ])
      : setEditingAllMembersDetails(
          editingAllMembersDetails.map((item) => {
            if (item.memberId === teacher?.id) {
              return { ...item, nextRole: e.target.value };
            } else {
              return item;
            }
          })
        );
  };

  const handleDeleteMember = () => {
    if (deletingTeachers.includes(teacher.id)) {
      const newTeachersList = deletingTeachers.filter((a) => a !== teacher.id);
      setDeletingAllMembersDetails((prevState) => ({
        ...prevState,
        deletingTeachers: newTeachersList,
      }));
    } else {
      setDeletingAllMembersDetails((prev) => ({
        ...prev,
        deletingTeachers: [...prev.deletingTeachers, teacher.id],
      }));
    }
    setIsMemberUpdated(true);
  };
  return (
    // <>
    //   <div className="col-12 p-0 d-flex align-items-center justify-content-between ">
    //     <div className="col-4 p-0 mt-3 gap-2 d-flex align-items-center">
    //       <div className="member_account_img d-flex align-items-center justify-content-center">
    //       <div className="imgPic">
    //                 <div className="initialsPic">
    //                     {getInitial(teacher?.teacher?.name)}
    //                 </div>
    //             </div>
    //       </div>
    //       <span>{teacher?.teacher?.name}</span>
    //       {teacher?.teacher.id === teacher_id && (
    //         <span className="you">(you)</span>
    //       )}
    //     </div>
    //     {inEditingMode ? (
    //       <div className=" gap-3 d-flex">
    //         {teacher?.teacher.id !== teacher_id && (
    //           <Form.Select
    //             onChange={(e) => handleRoleChange(e)}
    //             defaultValue={teacher?.role}
    //             className={`${
    //               editingAllMembersDetails.some(
    //                 (member) => member.memberId === teacher?.id
    //               ) && `select_option_change`
    //             } custom-select`}
    //             size="sm"
    //           >
    //             <option value="admin">Admin</option>
    //             <option value="moderator">Moderator</option>
    //             <option value="member">Member</option>
    //           </Form.Select>
    //         )}
    //         {!deletingTeachers.includes(teacher.id) ? (
    //           <>
    //             {teacher?.teacher.id !== teacher_id && (
    //               <img
    //                 onClick={handleDeleteMember}
    //                 src="/images/Dustbin.svg"
    //                 alt=""
    //               />
    //             )}
    //           </>
    //         ) : (
    //           <img
    //             onClick={handleDeleteMember}
    //             src="/images/redDustbin.svg"
    //             alt=""
    //           />
    //         )}
    //       </div>
    //     ) : (
    //       <span>
    //         {teacher?.role?.charAt(0).toUpperCase() + teacher?.role?.slice(1)}
    //       </span>
    //     )}
    //   </div>
    // </>

    <Box
      key={teacher.id}
      sx={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        py: 1.5,
        px: 2,
        borderBottom: "1px solid #eee",
        bgcolor: index % 2 === 0 ? "#fafafa" : "transparent", // striped
        transition: "background-color 0.2s ease",
        "&:hover": {
          backgroundColor: "#f5f5f5", // light gray on hover
        },
        borderRadius: 2,
      }}
    >
      {/* Left: Avatar + Name */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Avatar sx={{ bgcolor: "orange", width: 40, height: 40 }}>
          {getInitial(teacher?.teacher?.name)}
        </Avatar>

        <Box>
          <Typography variant="body1" fontWeight={500}>
            {teacher?.teacher?.name}
          </Typography>

          {teacher?.teacher.id === teacher_id && (
            <Chip
              label="You"
              size="small"
              variant="outlined"
              sx={{
                mt: 0.5,
                borderRadius: "12px",
                fontSize: "0.75rem",
                height: "24px",
                color: "primary.main",
                borderColor: "primary.main",
              }}
            />
          )}
        </Box>
      </Box>

      {/* Right: Dropdown or Role + Delete */}
      {inEditingMode ? (
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          {teacher?.teacher.id !== teacher_id && (
            <Select
              value={
                editingAllMembersDetails.find((m) => m.memberId === teacher?.id)
                  ?.nextRole || teacher?.role
              }
              onChange={(e) => handleRoleChange(e)}
              size="small"
              sx={{
                fontSize: "0.85rem",
                borderRadius: 2,
                minWidth: 120,
                ...(editingAllMembersDetails.some(
                  (member) => member.memberId === teacher?.id
                ) && {
                  border: "2px solid orange",
                }),
              }}
            >
              <MenuItem value="admin">Admin</MenuItem>
              <MenuItem value="moderator">Moderator</MenuItem>
              <MenuItem value="member">Member</MenuItem>
            </Select>
          )}

          {teacher?.teacher.id !== teacher_id && (
            <Box
              component="img"
              onClick={handleDeleteMember}
              src={
                deletingTeachers.includes(teacher.id)
                  ? "/images/redDustbin.svg"
                  : "/images/Dustbin.svg"
              }
              alt="delete"
              sx={{ width: 24, height: 24, cursor: "pointer" }}
            />
          )}
        </Box>
      ) : (
        <Chip
          label={
            teacher?.role?.charAt(0).toUpperCase() + teacher?.role?.slice(1) ||
            ""
          }
          size="small"
          variant="outlined"
          color={
            teacher?.role === "admin"
              ? "success"
              : teacher?.role === "moderator"
              ? "info"
              : "default"
          }
          sx={{ borderRadius: "12px", fontSize: "0.75rem", px: 1.5 }}
        />
      )}
    </Box>
  );
};

export default IndividualsMember;
